module.exports = __webpack_public_path__ + "img/tile-04.4704c517.png";